import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

const faqs = [
  {
    question: 'What does the percentage score mean in the GPU comparison?',
    answer: 'The percentage score represents relative performance compared to the RTX 4090, which is set at 100%. For example, a GPU with 50% performance will deliver roughly half the frame rates of the RTX 4090 in most games.',
  },
  {
    question: 'How do I choose the right GPU for my resolution?',
    answer: 'For 1080p gaming, GPUs in the 30-50% range offer excellent performance. For 1440p, look for 50-70%. For 4K gaming at high settings, you\'ll want 70% or higher. Our tier markers help indicate which GPUs are best for each resolution.',
  },
  {
    question: 'Why might real-world performance differ from these rankings?',
    answer: 'Game optimization varies by title and GPU brand. Some games favor NVIDIA, others AMD. Driver updates can also improve performance. These rankings represent average performance across many titles.',
  },
  {
    question: 'Should I choose NVIDIA, AMD, or Intel?',
    answer: 'NVIDIA offers the best ray tracing and DLSS upscaling. AMD provides excellent value and good performance. Intel Arc cards are budget-friendly with improving driver support. Your choice depends on budget, features needed, and game preferences.',
  },
  {
    question: 'How often is this GPU comparison updated?',
    answer: 'We update our GPU comparison chart whenever new graphics cards are released or when significant driver updates change performance rankings. Check the "last updated" date at the top for the most recent update.',
  },
  {
    question: 'What about VRAM requirements?',
    answer: 'Modern games at 4K often need 12GB+ VRAM. At 1440p, 8GB is usually sufficient for most titles. We list VRAM for each GPU to help you make an informed decision based on your target resolution.',
  },
];

export const FAQSection = () => {
  return (
    <section id="faq" className="py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl font-bold text-foreground mb-4 text-center">
            Frequently Asked Questions
          </h2>
          <p className="text-muted-foreground text-center mb-8">
            Common questions about our GPU comparison and choosing the right graphics card.
          </p>

          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-left font-medium">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
